
export class TextClass {    
  
    constructor(data){
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
    }
}